import {
  compose,
  withHandlers,
  withProps,
  withState
} from 'recompose';
import BeforeExtendVoucherBody from './BeforeExtendVoucher';

export const withExtendVoucherState = compose(
  withState('open', 'showModal', false),
);

export const withOnClickToExtendVoucher = compose(
  withHandlers({
    openModal: ({showModal}) => () => showModal(true),
    closeCallback: ({showModal}) => () => showModal(false),
    extendCallback: ({
      showModal,
      voucherCode,
      update,
      updateVouchersData,
      currentPageNumber,
      t
    }) => () => {
      update(voucherCode, {page: currentPageNumber})
        .done(response => {
          showModal(false);
          updateVouchersData(true, response.data, currentPageNumber);
        })
        .fail(response => alert(t("account.voucher_withextendvoucher_fail", "failed to extend")));
    },
  }),
);

export const withExtendVoucherModal = compose(
  withProps({
    size: 'sm',
    modalBody: BeforeExtendVoucherBody,
  }),
);



// WEBPACK FOOTER //
// ./src/Account/Voucher/withExtendVoucher.js